import { INVITATION_PLANS } from "../../values/plans";
import { CONTACT_INFO } from "../../values/constants";
import { generateWhatsAppUrl } from "../../utils/formatters";
import { getWhatsAppPath } from "../../utils/device";
import "./PlansSection.css";

const PlansSection = () => {
  const whatsappUrl = (message_send) => {
    return generateWhatsAppUrl(
      CONTACT_INFO.whatsapp.number,
      message_send,
      getWhatsAppPath(),
    );
  };

  return (
    <section className="plans-section" id="planes">
      <div className="container">
        <div className="row plans-row">
          {INVITATION_PLANS.map((plan) => (
            <div
              key={plan.id}
              className={`col-md-4 plan-column ${plan.featured ? "featured" : ""}`}
            >
              <div className="plan-card">
                {/* Icono y nombre del plan */}
                <div className="plan-header">
                  <h4 className="plan-name">{plan.name}</h4>
                </div>

                {/* Precio */}
                <div className="plan-price">
                  <p
                    className={`price ${plan.id === "gold" ? "text-yellow" : "text-info"}`}
                  >
                    {plan.price}
                  </p>
                </div>

                {/* Lista de características */}
                <div className="plan-features">
                  {plan.features
                    // .filter((feature) => feature.enabled)
                    .map((feature, index) => (
                      <div key={index} className="plan-feature">
                        <p className={`${feature.enabled ? "enabled" : "disabled"}`}>{feature.text}</p>
                      </div>
                    ))}
                </div>

                {/* Botones de acción */}
                <div className="plan-actions">
                  <a href={plan.detailsUrl} className="btn btn-details">
                    Ver más
                  </a>
                  <a
                    id={plan.buttonId}
                    href={generateWhatsAppUrl(
                      CONTACT_INFO.whatsapp.number,
                      plan.message,
                      getWhatsAppPath(),
                    )}
                    rel="noopener noreferrer"
                    target="_blank"
                    className="btn btn-primary"
                  >
                    Contratar
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PlansSection;
